<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div class="p-3 h-100" style="background-color: white;">
    <div class="d-flex flex-column py-2">
        <div class="" style="font-size: 18px;">For queries and support feel free to contact us</div>
        <div style="color: #757575; font-size: 14px;">Available from 9AM - 7PM for calls</div>
        <div style="color: #757575; font-size: 14px;">Contact us on whatsapp anytime</div>
    </div>

    <hr class="w-100 my-1">
    <div class="d-flex flex-column py-2">
        <div style="color: #757575; font-size: 18px; font-weight: 600;">Care Contact 1</div>
        <div class="d-flex align-items-center justify-content-between" style="gap:0.5rem;">
            <div (click)="callNumber('919633223355')" style="color: #673AB7; font-size: 18px; font-weight: 600;">+919633223355 <span style="font-size: 10px; color: #757575;">(Tap to call)</span></div>
            <i style="color: #673AB7; font-size: 18px;" (click)="callNumber('919633223355')" class="bi bi-telephone-fill mr-2"></i>
        </div>
        <div class="mt-1" style="font-size: 14px; color: #673AB7;cursor:pointer;" (click)="openWhatsApp('919633223355')">Message on WhatsApp</div>
    </div>

    <hr class="w-100 my-1">
    <div class="d-flex flex-column py-2">
        <div style="color: #757575; font-size: 18px; font-weight: 600;">Care Contact 2</div>
        <div class="d-flex align-items-center justify-content-between" style="gap:0.5rem;">
            <div (click)="callNumber('919633777066')" style="color: #673AB7; font-size: 18px; font-weight: 600;">+919633777066 <span style="font-size: 10px; color: #757575;">(Tap to call)</span></div>
            <i style="color: #673AB7; font-size: 18px;" (click)="callNumber('919633777066')" class="bi bi-telephone-fill mr-2"></i>
        </div>
        <div class="mt-1" style="font-size: 14px; color: #673AB7;cursor:pointer;" (click)="openWhatsApp('919633777066')">Message on WhatsApp</div>
    </div>
    
    <hr class="w-100 my-1">
    <div class="d-flex flex-column py-2">
        <div style="color: #757575; font-size: 18px; font-weight: 600;">Care Contact 3</div>
        <div class="d-flex align-items-center justify-content-between" style="gap:0.5rem;">
            <div (click)="callNumber('919895070723')" style="color: #673AB7; font-size: 18px; font-weight: 600;">+919895070723 <span style="font-size: 10px; color: #757575;">(Tap to call)</span></div>
            <i style="color: #673AB7; font-size: 18px;" (click)="callNumber('919895070723')" class="bi bi-telephone-fill mr-2"></i>  
        </div>
        <div class="mt-1" style="font-size: 14px; color: #673AB7;cursor:pointer;" (click)="openWhatsApp('919895070723')">Message on WhatsApp</div>
    </div>
    <hr class="w-100 my-1">
    <div class="d-flex flex-column py-2">
        <div style="color: #757575; font-size: 18px; font-weight: 600;">Help Video</div>
        <div style="color: #673AB7; font-size: 18px; font-weight: 600;" (click)="openYoutube()">Youtube link <span style="font-size: 10px; color: #757575;">(Tap for demo video)</span></div>
        <!-- <div>You tube video link</div> -->
    </div>
</div>
